import './styles/global.scss'
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from './components/layout/Layout';
import HomePage from './pages/home';
import SignInPage from './pages/signin';
import SignUpPage from './pages/signup';
import SubscriptionPage from './pages/subscription';
import MePage from './pages/me';
import PaymentHistoryPage from './pages/payment-history';
import { useEffect } from 'react';
import { Storage } from './utils/Storage';
import { UserApi } from './api/User.api';
import { useAppDispatch } from './store';
import { setUser } from './store/modules/app';
import SignInTypePage from './pages/signin/Type.page';
import PolicyPage from './pages/policy';
import SuccessSignUpPage from './pages/signup/success.page';
import ApplyPage from './pages/apply';
import FindIdPage from './pages/find-id';
import ResetPasswordPage from './pages/reset-password';
import CertificatePage from './pages/certificate';
import NoticePage from './pages/notice';
import NoticeDetailPage from './pages/notice/detail.page';
import AdvisePage from './pages/advise';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import ReviewPage from './pages/review';
import PaymentPage from './pages/payment';
import AddOnPage from './pages/addon';
import PaymentCompletePage from './pages/payment/complete';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const firebaseConfig = {
  apiKey: "AIzaSyDf-2jQFsllhtqeWT67-oWqRPWYuh8GB2c",
  authDomain: "seller-guard.firebaseapp.com",
  projectId: "seller-guard",
  storageBucket: "seller-guard.appspot.com",
  messagingSenderId: "314519394851",
  appId: "1:314519394851:web:c63f45aa9ff5b7b7d1ef96",
  measurementId: "G-932XPM2TYB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const queryClient = new QueryClient();

export default function App() {

  const dispatch = useAppDispatch()
  
  useEffect(() => {
    const token = Storage.getString('token')

    if(token !== null) {
      getUser()
    }
    else {
      dispatch(setUser(null))
    }
  }, [])

  const getUser = () => {
    UserApi.getMe()
    .then(result => {
      dispatch(setUser(result))
    }).catch(error => {
      Storage.remove('token')
      dispatch(setUser(null))
    })
  }
  
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
      <ScrollTop/>
        <Routes>
          <Route path="/signin/:type" element={<SignInTypePage />} />
          
          <Route path="/" element={<Layout />}>
            <Route path="" element={<HomePage />} />
            <Route path="signin" element={<SignInPage />} />
            <Route path="certificate" element={<CertificatePage />} />
            <Route path="find-id" element={<FindIdPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route path="signup" element={<SignUpPage />}/>
            <Route path="signup/success" element={<SuccessSignUpPage />} />
            <Route path="me" element={<MePage />} />
            <Route path="payment-history" element={<PaymentHistoryPage />} />

            <Route path="subscription" element={<SubscriptionPage />}/>
            <Route path="apply" element={<ApplyPage />} />
            <Route path="advise" element={<AdvisePage />} />

            <Route path="notice" element={<NoticePage />} />
            <Route path="notice/:id" element={<NoticeDetailPage />} />

            <Route path='review' element={<ReviewPage />} />

            <Route path="/policy/:type" element={<PolicyPage />} />

            <Route path='payment' element={<PaymentPage />}/>
            <Route path='payment/complete' element={<PaymentCompletePage />}/>

            <Route path='addon' element={<AddOnPage />}/>

          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}


const ScrollTop = () => {

  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return <></>
}

// export function GetLayout(page: ReactElement) {

//   return (
//     <Layout>
//       {page}
//     </Layout>
//   )
// }